import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-our-software',
  templateUrl: './our-software.component.html',
  styleUrls: ['./our-software.component.scss'],
})
export class OurSoftwareComponent {
  ourSoftwareList = [
    {
      image: 'https://flowaccountcdn.com/new_landing/image/mobile/Head/App2_new.jpg',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/mobile/Head/App2_new.jpg',
      imageAlt: 'FlowAccount Image Cover',
      imageType: 'jpg',

      logoImage: 'https://flowaccountcdn.com/logo_favicon/flowaccount.svg',
      logoImageWebP: 'https://flowaccountcdn.com/logo_favicon/flowaccount.svg',
      logoImageAlt: 'FlowAccount logo',
      logoImageType: 'svg',

      softwareName: 'FlowAccount',
      softwareDetail: 'WORK_WITH_US.OUR_SOFTWARE.ITEM.FA_HEADING',
    },
    {
      image: 'https://flowaccountcdn.com/landing_payroll/image/mobile/Head/Image_Silde_2.webp',
      imageWebP: 'https://flowaccountcdn.com/landing_payroll/image/mobile/Head/Image_Silde_2.jpg',
      imageAlt: 'PayrollImage Cover',
      imageType: 'jpg',

      logoImage: 'https://flowaccountcdn.com/logo_favicon/flowaccount-payroll-green.png',
      logoImageWebP: 'https://flowaccountcdn.com/logo_favicon/flowaccount-payroll-green.png',
      logoImageAlt: 'Payroll logo',
      logoImageType: 'svg',

      softwareName: 'Payroll',
      softwareDetail: 'WORK_WITH_US.OUR_SOFTWARE.ITEM.PAYROLL_HEADING',
    },
    {
      image: 'https://flowaccountcdn.com/AUTOKEY_LANDING/firstdiv/Header_1.jpg',
      imageWebP: 'https://flowaccountcdn.com/AUTOKEY_LANDING/firstdiv/Header_1.webp',
      imageAlt: 'AutoKey Image Cover',
      imageType: 'jpg',

      logoImage: 'https://flowaccountcdn.com/AUTOKEY_LANDING/Favicon_Landing_AutoKey.png',
      logoImageWebP: 'https://flowaccountcdn.com/AUTOKEY_LANDING/Favicon_Landing_AutoKey.png',
      logoImageAlt: 'AutoKey logo',
      logoImageType: 'png',

      softwareName: 'AutoKey',
      softwareDetail: 'WORK_WITH_US.OUR_SOFTWARE.ITEM.AUTOKEY_HEADING',
    },
  ]

  constructor(public translate: TranslateService) {}
}
